import { Button, Preloader } from "framework7-react";

const style = {
  marginTop: "1em",
  // MD outlines use the neutral outline color; keep the border red.
  "--f7-button-outline-border-color": "currentColor",
};

const DeleteButton = ({
  busy = false,
  disabled = false,
  onClick,
  className,
  children,
}) => (
  <Button
    className={className}
    color="red"
    outline
    disabled={disabled || busy}
    onClick={onClick}
    style={style}
  >
    {busy ? <Preloader size={20} color="red" /> : children}
  </Button>
);

export default DeleteButton;
